import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { EmployeeService } from 'src/app/services/core/services/employee/employee.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { debounceTime, filter, Subject } from 'rxjs';
@UntilDestroy()

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit, OnDestroy {

  numberOfRecords = NUMBER_OF_RECORDS;
  search: any = '';
  private searchSubject = new Subject<string>();
  employees :any
  filteredEmployees:any;
  employeeDetail:any;
  loadingId = null;
  syncType = null;
  selectedDropdownId: any;
  toggleActionButtons = false;
  companies:any;
  preCompanies:any;
  selectedCompanyId = null;

  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;

  constructor(
    private companyService : CompanyService,
    private employeeService: EmployeeService) { }

  ngOnInit(): void {
    this.getCompanies();
    this.initializeSearch();
    this.getAllEmployee(this.currentPage);
  }

  getAllEmployee(page:any) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,
    }
    if (this.search) {
      queryParams.search = this.search.trim();
    }
    if (this.selectedCompanyId) {
      queryParams.company = this.selectedCompanyId;
    }
    this.employeeService.getEmployee(queryParams)
      .pipe(untilDestroyed(this)).subscribe({
        next: (data: any) => {
          if (data) {
            this.employees = data.results
            this.filteredEmployees = this.employees;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
        }
      })
  }

  ngOnDestroy(): void {
      
  }

   opendetailModal(item: any) {
    this.employeeDetail = item;
    console.log('employeeDetail', this.employeeDetail);
  }

   async onSyncEmployee(emp: any, type: any) {
    const mPull = 'Are you sure you want to overwrite employee data with QuickBooks data?';
    const mPush = 'Are you sure you want to overwrite the QuickBooks data with employee data';
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;

    this.loadingId = emp.id;
    this.syncType = type;
    if (type === 'pull') emp.pulling = true; else emp.pushing = true;
    this.closeActionMenu();
    this.employeeService.syncEmployee(emp.company.id, emp.id, { isSyncFrom: type === 'pull' }).subscribe(
      {
      next: (data: any) => {
     this.getAllEmployee(this.currentPage);
     sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
    },
    error: (err) => {
      sweetAlert('Error', err, 'error', 'Ok');
      emp.pulling = false;
      emp.pushing = false;
    },
    complete: () => {
      this.loadingId = null;
      this.syncType = null;
      emp.pulling = false;
      emp.pushing = false;
    }
    })
  }

  showActionButtons(id: any) {
    this.selectedDropdownId = id;
    this.toggleActionButtons = true;
  }

  closeActionMenu(_event?: any) {
    this.selectedDropdownId = null;
    this.toggleActionButtons = false;
  }

   getCompanies() {
    this.companyService.getCompanies().subscribe((data: any) => {
      if (data) {
        this.companies = data.results
        this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

   filterEmployees() {
    this.currentPage = 1;
    this.getAllEmployee(this.currentPage);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3),
        untilDestroyed(this)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllEmployee(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

   onPageChange(page: number) {
    this.currentPage = page;
    this.getAllEmployee(page);
  }

}
